<script setup lang="ts">
import {Sharing} from "@/core/interfaces/Sharing";
import {Select, SelectContent, SelectItem, SelectTrigger, SelectValue} from "@/core/components/ui/select";
import {AcceptableValue} from "reka-ui";

const props = defineProps<{
    sharings: Sharing[]
}>();

const modelValue = defineModel<undefined | Sharing>({
    required: true
});

const handleChange = (id: AcceptableValue) => {
    const selectedSharing = props.sharings.find(sharing => sharing.id.toString() === id);
    modelValue.value = selectedSharing || undefined;
};
</script>

<template>
  <Select :model-value="modelValue?.id.toString()" @update:model-value="handleChange">
    <SelectTrigger class="w-auto">
      <SelectValue placeholder="Sélectionnez l'établissement qui recevra le message" />
    </SelectTrigger>
    <SelectContent>
      <SelectItem v-for="sharing in sharings" :key="sharing.id" :value="sharing.id.toString()">
        {{ sharing.tenant_name }}
      </SelectItem>
    </SelectContent>
  </Select>
</template>
